import { render, staticRenderFns } from "./ShopProducts.vue?vue&type=template&id=04eefece&"
import script from "./ShopProducts.vue?vue&type=script&lang=js&"
export * from "./ShopProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports